import React, { Component, useRef } from "react";
import Slider from "react-slick";
import { BenifitItem } from "../soundboxwork";
import instant from "../../assets/svgs/prepaidcard/seamless.svg";
import languge from "../../assets/svgs/prepaidcard/keep.svg";
import accept from "../../assets/svgs/prepaidcard/does.svg";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useWindowSize } from "@uidotdev/usehooks";
import support from "../../assets/svgs/soundbox/support.svg";

import PropTypes from "prop-types";

export const SliderPrepaid = () => {
  const sliderRef = useRef(null);
  const { width } = useWindowSize();
  let isswipe;
  let show;
  let isInfinite;

  if (width > 1023) {
    isswipe = 3;
    show = false;
  } else if (width < 1024 && width > 871) {
    isswipe = 2;
    show = true;
  } else {
    isswipe = 1;
    show = true;
  }

  const { t } = useTranslation();
  const settings = {
    dots: true,
    arrows: false, // Ẩn các mũi tên điều hướng
    infinite: true,
    speed: 500,
    slidesToShow: isswipe,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  const totalSlides = 6;
  return (
    <div className="pb-[54px] pt-[20px]">
      <div className="slider-container ml-[30px] sm:ml-0">
        <Slider ref={sliderRef} {...settings}>
          <BenifitItem
            image={instant}
            titleheader={t("prepaid.aseamless")}
            title={t("prepaid.aseamlessdes")}
          />
          <BenifitItem
            image={languge}
            titleheader={t("prepaid.easy")}
            title={t("prepaid.easydes")}
          />
          <BenifitItem
            image={accept}
            titleheader={t("prepaid.dont")}
            title={t("prepaid.dontdes")}
          />

          <BenifitItem
            image={support}
            titleheader={t("prepaid.nothird")}
            title={t("prepaid.nothirddes")}
          />
        </Slider>
      </div>
    </div>
  );
};
